import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineImpersonate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M12.396 5A.59.59 0 0 0 13 4.403a.59.59 0 0 0-.597-.603.6.6 0 0 0-.428.171.57.57 0 0 0-.175.425q0 .254.171.429a.57.57 0 0 0 .425.175m-2.4 0a.59.59 0 0 0 .604-.597.59.59 0 0 0-.597-.603.6.6 0 0 0-.428.171.57.57 0 0 0-.175.425.59.59 0 0 0 .596.604m1.223 1.4a2.2 2.2 0 0 0-.825.158 1.43 1.43 0 0 0-.644.509q-.135.165 0 .35.132.183.416.183h2.117q.25 0 .375-.183.124-.185-.008-.35a1.56 1.56 0 0 0-.625-.5 2 2 0 0 0-.806-.167m-6.42 8q-1.666 0-2.833-1.167Q.8 12.067.8 10.4V6.8q0-.495.362-.848.362-.352.87-.352H7.6q.495 0 .847.352.353.353.353.848v3.6q0 1.667-1.167 2.833T4.8 14.4m0-1.2a2.7 2.7 0 0 0 1.984-.817A2.7 2.7 0 0 0 7.6 10.4V6.8H2v3.6a2.7 2.7 0 0 0 .816 1.983A2.7 2.7 0 0 0 4.8 13.2M15.2 2.8v3.633q0 1.686-1.166 2.827-1.167 1.14-2.833 1.14-.273 0-.536-.025a2.2 2.2 0 0 1-.506-.108.62.62 0 0 1-.358-.306.55.55 0 0 1-.034-.46.61.61 0 0 1 .308-.352.56.56 0 0 1 .459-.032q.183.04.35.062t.35.021q1.149 0 1.957-.808.81-.81.81-1.959V2.8H8.4v1.4q0 .255-.172.427a.57.57 0 0 1-.425.173.59.59 0 0 1-.428-.173A.58.58 0 0 1 7.2 4.2V2.8q0-.495.352-.848.353-.352.848-.352H14q.495 0 .847.352.353.353.353.848M3.597 9a.6.6 0 0 0 .429-.172.57.57 0 0 0 .175-.425.6.6 0 0 0-.172-.428.57.57 0 0 0-.425-.175.6.6 0 0 0-.428.171.57.57 0 0 0-.175.425.59.59 0 0 0 .596.604m2.4 0a.6.6 0 0 0 .429-.172.57.57 0 0 0 .175-.425.6.6 0 0 0-.172-.428.57.57 0 0 0-.425-.175.6.6 0 0 0-.428.171.57.57 0 0 0-.175.425.59.59 0 0 0 .596.604m-1.182 2.6q.435 0 .81-.167.375-.165.626-.5.132-.165.008-.35-.124-.183-.375-.183H3.766q-.284 0-.416.183-.135.185 0 .35.25.35.639.509.39.158.825.158"
      />
    </g>
  </svg>
);
export default SvgStreamlineImpersonate;
